import { TrackClient } from '@galigeo-store/ui-lib';

export class LoggerClient {
  public static async log(action: string, msg: string): Promise<void> {
    await TrackClient.log({
      action,
      msg,
      product: 'portal',
    });
  }

  public static async getLogs() {
    return await TrackClient.getLogs();
  }
}
